import type { Inquiry } from "@/types/inquiry";

const KEY = "warehouse_inquiries_v1";

function read(): Inquiry[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as Inquiry[]) : [];
  } catch {
    return [];
  }
}

function write(items: Inquiry[]) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

function makeId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function loadInquiries(): Inquiry[] {
  return read().sort((a, b) => (b.createdAt ?? "").localeCompare(a.createdAt ?? ""));
}

export function addInquiry(input: Omit<Inquiry, "id" | "createdAt">): Inquiry {
  const items = read();

  const inquiry: Inquiry = {
    id: makeId(),
    createdAt: new Date().toISOString(),
    ...input,
  };

  items.push(inquiry);
  write(items);
  return inquiry;
}

export function deleteInquiry(id: string): void {
  write(read().filter((x) => x.id !== id));
}

export function deleteAllInquiries(): void {
  write([]);
}
